<template>
    <!-- «Гаряча піца»: таймер прихований (10–25 с), піцу передають будь-кому кнопкою з ім'ям.
         Що ближче кінець — то частіше пульсує й вібрує; у кого піца, коли «обпекла», той платить -->
    <div class="bp-wp-game">
        <p class="bp-wp-turn" aria-live="polite">
            <template v-if="state == 'ready'">Передавайте піцу одне одному — коли обпече, хтось платить</template>
            <template v-else-if="state == 'play'">Піца в руках: <b>{{ players[holder] }}</b></template>
            <template v-else>Обпекла: <b>{{ players[holder] }}</b>!</template>
        </p>
        <div class="bp-wp-hot" :class="'is-' + state" :style="{ '--bp-heat': heat }">
            <img v-if="photo" :src="photo" alt="" class="bp-wp-hot__pizza">
            <span v-else class="bp-wp-hot__ic" v-html="icons.flame"></span>
        </div>
        <button v-if="state == 'ready'" type="button" class="bp-wp-btn bp-wp-btn--main" @click="start()">Почати — піца в {{ players[holder] }}</button>
        <div v-else-if="state == 'play'" class="bp-wp-pass">
            <span class="bp-wp-pass__label">Передати:</span>
            <button v-for="i in others" :key="i" type="button" class="bp-wp-btn" @click="pass(i)">{{ players[i] }}</button>
        </div>
    </div>
</template>

<script>
import { ICONS } from '@/v2icons'

export default {
    name: 'GameHot',
    props: {
        players: { type: Array, required: true },
        photo: { type: String, default: '' }
    },
    data() {
        return {
            icons: ICONS,
            holder: Math.floor(Math.random() * this.players.length),
            state: 'ready',
            // 0 → 1: наскільки близько кінець (пульс частішає)
            heat: 0,
            total: 0,
            started: 0,
            timer: null,
            tick: null
        }
    },
    computed: {
        others() {
            return this.players.map((_, i) => i).filter(i => i != this.holder);
        }
    },
    beforeDestroy() {
        clearTimeout(this.timer);
        clearInterval(this.tick);
    },
    methods: {
        buzz(ms) {
            try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) { /* немає вібрації */ }
        },
        start() {
            this.total = 10000 + Math.random() * 15000;
            this.started = performance.now();
            this.state = 'play';
            this.tick = setInterval(() => { this.heat = Math.min(1, (performance.now() - this.started) / this.total); }, 200);
            this.timer = setTimeout(() => this.burn(), this.total);
        },
        pass(i) {
            if (this.state != 'play') return;
            this.holder = i;
            this.buzz(25);
        },
        burn() {
            clearInterval(this.tick);
            this.heat = 1;
            this.state = 'done';
            this.buzz([300, 80, 300]);
            setTimeout(() => this.$emit('done', { loser: this.holder, note: 'Гаряча піца була в руках' }), 1300);
        }
    }
}
</script>
